import { useMutation, useQuery } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import { useLocale } from 'next-intl';
import { QueryApi } from '@/features/query/api';
import { languageCurrencyMap } from '@/shared/i18n/constants';
import { Currency } from '@/shared/model/Currency';

export const useSelectedCurrency = (): [Currency, (currency: Currency) => void] => {
    const locale = useLocale();
    const { data: venue } = useQuery(QueryApi.Venue.queries.Venue);
    const { data: currency } = useQuery(QueryApi.Currency.queries.GetCurrency);
    const selectedCurrency = (currency ||
        venue?.currencies?.find((cur) => cur === languageCurrencyMap[locale]) ||
        venue?.currencies?.[0]) as Currency | undefined;

    const changeCurrencyMutation = useMutation(QueryApi.Currency.mutations.ChangeCurrency);
    const handleSelectCurrency = (currency: string) => {
        Cookies.set('currency', currency);
        changeCurrencyMutation.mutate(currency);
    };

    return [selectedCurrency!, handleSelectCurrency];
};
